import { ShieldCheck } from "lucide-react";

export function CertifiedBadge({ tier = "standard", compact = false }) {
  const isPremium = tier === "premium";
  const label = isPremium ? "Premium Certified" : "Certified Fresh";
  if (compact) {
    return (
      <span
        data-testid="certified-badge"
        className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] tracking-[0.16em] uppercase font-semibold ${
          isPremium ? "bg-[#F9F3E5] text-[#0A1128] border border-[#D4AF37]" : "bg-emerald-50 text-emerald-700 border border-emerald-200"
        }`}
      >
        <ShieldCheck className="w-3 h-3" /> {label}
      </span>
    );
  }
  return (
    <div
      data-testid="certified-badge-hero"
      className={`inline-flex items-center gap-3 px-5 py-3 rounded-full border-2 ${
        isPremium ? "border-[#D4AF37] bg-white" : "border-emerald-500 bg-white"
      }`}
    >
      <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
        isPremium ? "bg-[#0A1128]" : "bg-emerald-500"
      }`}>
        <ShieldCheck className={`w-5 h-5 ${isPremium ? "text-[#D4AF37]" : "text-white"}`} />
      </div>
      <div>
        <div className="text-[10px] tracking-[0.28em] text-slate-500 uppercase">Guest Smell™</div>
        <div className="font-serif text-lg text-[#0A1128] leading-none">{label}</div>
      </div>
    </div>
  );
}
